import React from "react"
import type { TextProps } from "@chakra-ui/react"
import { Text } from "@chakra-ui/react"
import { useCurrencySymbol } from "hooks"
import { getPriceString } from "./Price.utils"

type Props = TextProps & {
  price: number
  isTypical?: boolean
  signSymbol?: string
  isDiscount?: boolean
}

export const Price: React.FC<Props> = ({
  price,
  isTypical = false,
  signSymbol = "",
  isDiscount = false,
  ...otherProps
}) => {
  const currencySym = useCurrencySymbol()
  const priceString = getPriceString(price, currencySym, isTypical, isDiscount)

  return (
    <Text
      as="span"
      mt={0}
      {...otherProps}
    >{`${signSymbol}${priceString}`}</Text>
  )
}
